module.exports = "/_next/static/images/fe62ae55116bcf24f10da8f075e0c094-hands-holding-cards-xs@3x.jpg.webp";